module.exports = __webpack_public_path__ + "media/images/athletes/426-c3e2aa958fe59a6537bfe8c5e31ba9fd.png";